import React, { useState } from "react";
import { Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Row, UncontrolledDropdown } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb"
import { MetaTags } from "react-meta-tags";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import SfLoadingSkeleton from "components/Common/Loadings/SfLoadingSkeleton";
import BootstrapTable from 'react-bootstrap-table-next';
import { AppConfiguration } from 'config';
import { useDispatch } from "react-redux";
import { DEFAULT_TABLE_SORT_BY_CREATED_AT_IN_DESC, MODE, TRANSACTION_TYPE, TRUE_AND_FALSE } from "helpers/sf_constants";
import { dateCreatedFormatter } from "pages/Admin/Users/UserComponents/UserList/Formatters";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { forColumnHeaderWrapper, getPrimaryButtonClass } from "helpers/sf_utils";
import { customSortCaret } from "helpers/bootstrap_table_helper";
import useReceiptTypes from "hooks/useReceiptTypes";
import CreateReceiptTypesModal from "./CreateReceiptTypesModal";
import { createReceiptTypes } from "store/receipts/actions";

let nameFilter = null;

const ReceiptTypes = () => {
    const dispatch = useDispatch();

    const [selectedName, setSelectedName] = useState('');

    const {
        receipt_types,
        loading_receipt_types
    } = useReceiptTypes();

    const [updateInsuranceCarrierModal, setUpdateInsuranceCarrierModal] = useState({ active: false, mode: null, row: null });

    /**
     * 
     * @param {boolean} action  // true for open modal, false for close modal
     * @param {string} mode  // create or update 
     * @param {object} row  // row data¸
     */
    const onClickhandleModalState = (active, mode = null, row = null) => {
        setUpdateInsuranceCarrierModal({ active, mode, row });
    }

    const onSubmitUpdatedState = (mode, data) => {
        if (mode === MODE.CREATE) {
            dispatch(createReceiptTypes(data));
        }
        //Need to implement when we want to add the edit functionality
        // else if (mode === MODE.EDIT) {
        // dispatch(updateReceiptTypes(data)); 
        // }
        onClickhandleModalState(TRUE_AND_FALSE.FALSE);
    }


    // for Option-Column-Formatter
    function OptionFormatter(_, row) {
        return (
            <div className="d-flex gap-3 justify-content-start">
                <UncontrolledDropdown>
                    <DropdownToggle
                        href="#"
                        className="card-drop"
                        tag="i"
                    >
                        <i className="mdi mdi-dots-horizontal font-size-18" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        <DropdownItem header className='text-black'>Options</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem onClick={() => onClickhandleModalState(TRUE_AND_FALSE.TRUE, MODE.EDIT, row)}>
                            <div>
                                Edit
                            </div>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
        );
    }

    const columns = [
        {
            dataField: "name",
            text: "Name",
            headerFormatter: forColumnHeaderWrapper,
            sort: true,
            filter: textFilter({
                style: {
                    display: 'none',
                },
                getFilter: (filter) => {
                    nameFilter = filter;
                },
            }),
        },
        {
            dataField: "is_debit",
            text: "Transaction Type",
            formatter: ((cell, row) => !!cell ? TRANSACTION_TYPE.DEBIT : TRANSACTION_TYPE.CREDIT),
            headerFormatter: forColumnHeaderWrapper,
            sort: true,
        },
        {
            dataField: "created_at",
            text: "Created At",
            headerFormatter: forColumnHeaderWrapper,
            sort: true,
            formatter: dateCreatedFormatter
        },
        {
            dataField: "",
            text: "Options",
            hidden: true, //Change or remove this if in future we need to implement the edit functionality
            sort: false,
            formatter: OptionFormatter
        },
    ]

    return (
        <React.Fragment>
            <div className="page-content" id="page-content-wrapper">
                <MetaTags>
                    <title>Receipt Types | {AppConfiguration.WEBSITE}</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="" backOption={false} breadcrumbItem="Receipt Types" />

                    <CreateReceiptTypesModal
                        show={updateInsuranceCarrierModal}
                        onSubmitUpdatedState={onSubmitUpdatedState}
                        onClickCloseModal={() => onClickhandleModalState(TRUE_AND_FALSE.FALSE)}
                        receipt_types={receipt_types}
                    />

                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <ToolkitProvider
                                        keyField="id"
                                        columns={columns}
                                        data={receipt_types}
                                    >
                                        {(toolkitProps) => (
                                            <>
                                                <Form>
                                                    <Row className="">
                                                        <Col md="auto" className='align-self-center'>
                                                            <FormGroup className="mb-0">
                                                                <div className="search-box me-2 d-inline-block">
                                                                    <div className="position-relative">
                                                                        <Input
                                                                            className="rounded"
                                                                            value={selectedName}
                                                                            placeholder="Search"
                                                                            onChange={(e) => {
                                                                                nameFilter(e.target.value);
                                                                                setSelectedName(e.target.value);
                                                                            }}
                                                                        />
                                                                        <i className="bx bx-search-alt search-icon" />
                                                                    </div>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xl="auto" className="ms-auto">
                                                            <Row>
                                                                <Col xl="auto">
                                                                    <FormGroup className="mb-0">
                                                                        <div>
                                                                            <a className={`btn ${getPrimaryButtonClass()}`}
                                                                                onClick={() => onClickhandleModalState(TRUE_AND_FALSE.TRUE, MODE.CREATE)}>
                                                                                <i className="bx bx-plus font-size-14 align-middle me-2" />
                                                                                New Receipt Type
                                                                            </a>
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                                <Row>
                                                    <Col xl="12">
                                                        <div
                                                            className="sfTable-Container"
                                                        >
                                                            {loading_receipt_types ? (
                                                                <SfLoadingSkeleton rows={8} cols={6} />
                                                            ) : (
                                                                <BootstrapTable
                                                                    keyField="id"
                                                                    columns={columns}
                                                                    data={receipt_types}
                                                                    responsive
                                                                    bordered={false}
                                                                    striped={false}
                                                                    defaultSorted={DEFAULT_TABLE_SORT_BY_CREATED_AT_IN_DESC}
                                                                    rowClasses="tr-hover"
                                                                    filter={filterFactory()}
                                                                    headerClasses="sftableHeader text-black thead-h50"
                                                                    classes="table align-middle table-nowrap text-black"
                                                                    headerWrapperClasses="thead-light"
                                                                    noDataIndication="You currently don't have any receipt types"
                                                                    sort={{ sortCaret: customSortCaret }}
                                                                    {...toolkitProps.baseProps}
                                                                />
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </ToolkitProvider>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {/* Table ends */}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ReceiptTypes